import styled from 'styled-components';

const TypoBase = styled.span`
  color: #353535;
`;

export default TypoBase;
